if (!customElements.get('section-announcement-bar')) {
  class TG_SectionAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.currentSlideIndex = 0;
      this.slides = [];
      this.rotationInterval = null;
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);

      this.options = JSON.parse(this.getAttribute('data-section-settings'));

      // Get all slides
      this.slides = Array.from(this.querySelectorAll('.Announcement__Slide'));
      
      // Only start slider if there are multiple slides
      if (this.slides.length > 1) {
        this._startSlider();
      }

      try {
        if (this.options['closeable'] && sessionStorage.getItem('AnnoucementClosed') === null) {
          this._openAnnoucement();
        }
      } catch (error) {
      }

      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      this._stopSlider();
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="close-annoucement"]', this._closeAnnoucement.bind(this));
    }

    _startSlider() {
      // Convert seconds to milliseconds (default 2 seconds)
      const intervalSeconds = this.options['rotationInterval'] || 2;
      const interval = intervalSeconds * 1000;
      
      this.rotationInterval = setInterval(() => {
        this._nextSlide();
      }, interval);
    }

    _stopSlider() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    }

    _nextSlide() {
      if (this.slides.length <= 1) return;

      // Get current and next slides
      const currentSlide = this.slides[this.currentSlideIndex];
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
      const nextSlide = this.slides[this.currentSlideIndex];

      // Start fade out on current slide
      currentSlide.classList.remove('Announcement__Slide--active');
      currentSlide.classList.add('Announcement__Slide--fade-out');

      // Prepare next slide and start fade in
      nextSlide.classList.remove('Announcement__Slide--fade-out');
      nextSlide.classList.add('Announcement__Slide--active');
      nextSlide.classList.add('Announcement__Slide--fade-in');
      
      // Clean up animation classes after transitions complete
      setTimeout(() => {
        currentSlide.classList.remove('Announcement__Slide--fade-out');
        nextSlide.classList.remove('Announcement__Slide--fade-in');
      }, 500);
    }

    _openAnnoucement() {
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', document.getElementById('AnnouncementBar').offsetHeight + 'px'); 
    }

    _closeAnnoucement() {
      this._stopSlider();
      sessionStorage.setItem('AnnoucementClosed', 'true');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', '0px');
    }
  }
  
  customElements.define('section-announcement-bar', TG_SectionAnnouncementBar);
}